import {
  CircleAlert as ErrorCircle24Regular,
  RefreshCw as ArrowClockwise24Regular,
  LogOut as SignOut24Regular,
} from "lucide-react";
import { useMsal } from "@azure/msal-react";
import { SkyButton, SkyCard, SkyBody1, SkyTitle2 } from "@skypointcloud/skypoint-ui";

interface AccountErrorScreenProps {
  onRetry: () => void;
}

export function AccountErrorScreen({ onRetry }: AccountErrorScreenProps) {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-surface-subtle">
      <SkyCard className="max-w-[440px] w-full flex flex-col items-center gap-4 text-center px-8 py-10">
        <ErrorCircle24Regular
          className="text-fg-danger w-[48px] h-[48px]"
          fontSize={48}
        />
        <SkyTitle2 className="mt-2">Something went wrong</SkyTitle2>
        <SkyBody1 className="text-fg-2">
          We couldn&apos;t verify your access. Please try again or contact support if the problem
          persists.
        </SkyBody1>
        <div className="mt-2 flex flex-col items-center gap-3 w-full">
          <SkyButton
            appearance="primary"
            icon={ArrowClockwise24Regular}
            onClick={onRetry}
          >
            Try Again
          </SkyButton>
          <SkyButton
            appearance="secondary"
            icon={SignOut24Regular}
            onClick={handleSignOut}
          >
            Sign Out
          </SkyButton>
        </div>
      </SkyCard>
    </div>
  );
}

export default AccountErrorScreen;
